import { render } from "./ModalCustomerPrefs.vue?vue&type=template&id=53c5084f"
import script from "./ModalCustomerPrefs.vue?vue&type=script&lang=js"
export * from "./ModalCustomerPrefs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__